import { render, staticRenderFns } from "./customers.select.vue?vue&type=template&id=1e7d8b27"
import script from "./customers.select.vue?vue&type=script&lang=js"
export * from "./customers.select.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports